/*
* プロジェクト詳細画面_収益シミュレーション機能
*/

export default class Simulation {
  constructor() {
    this.$simulationTrigger = document.querySelectorAll('[data-target="simulationAccordionTrigger"]');
    this.$targetBtn         = document.getElementById('simulation-button');
    this.$simulationContent = document.getElementById('simulation-content');

    this.$capitalAmount     = document.querySelector('[data-target="displayTotalAmount"]');
    this.$afterTax          = document.querySelector('[data-target="afterTax"]');
    this.$beforeTax         = document.querySelector('[data-target="beforeTax"]');
    this.$tax               = document.querySelector('[data-target="tax"]');
    this.$interest          = document.querySelector('[data-target="interestRate"]');

    this.$numberBoxStepUp   = document.querySelector('[data-target="numberBoxStepUp"]');
    this.$numberBoxStepDown = document.querySelector('[data-target="numberBoxStepDown"]');
    this.$numberBox         = document.querySelector('[data-target="numberBox"]');

    this.$operationStartDate = document.getElementById('operationStartDate');
    this.$operationEndDate   = document.getElementById('operationEndDate');

    this.$WITHHOLDING_TAX_RATE = 0.2042;
  }
  openSimulationAccordion() {
    if(this.$targetBtn == null) {
      return;
    }
    this.$targetBtn.addEventListener('click', () => {
      if(this.$simulationContent.classList.contains('is-open')) {
        this.$simulationContent.classList.remove('is-open');
      } else {
        this.$simulationContent.classList.add('is-open');
      }
    });
  }
  attachEvent() {
    if(this.$simulationTrigger.length == 0) {
      return;
    }
  }
  getProfitRate() {
    // 利益(通常分配金)の計算に使う年利。表示値をそのまま使う
    const parsed = Number(this.$interest.textContent);
    return Number.isFinite(parsed) ? parsed : 0;
  }
  getTaxRate() {
    // 源泉税の課税ベースとなるレート。data-simulation-tax-rate があれば優先し、なければ年利を使う
    const ds = this.$interest.dataset.simulationTaxRate;
    if (ds !== undefined && ds !== '') {
      const parsed = Number(ds);
      if (Number.isFinite(parsed)) return parsed;
    }
    return this.getProfitRate();
  }
  calculateSimulation() {
    const trimCapitalAmount  = Number(this.$capitalAmount.textContent.trim().replace('¥', '').replaceAll(',', ''));

    const operationStartDate = this.replaceToDateTimeFormat(this.$operationStartDate);
    const operationEndDate   = this.replaceToDateTimeFormat(this.$operationEndDate);
    const operationTerm      = ((Date.parse(operationEndDate) - Date.parse(operationStartDate)) / (24 * 60 * 60 * 1000)) + 1;

    // 通常分配金は年利分のみ。源泉税はアップフロントフィー込みの総額に課税されるため taxBase を別に算出する
    const profit             = trimCapitalAmount * (this.getProfitRate() * 0.01) * (operationTerm / 365);
    const taxBase            = trimCapitalAmount * (this.getTaxRate()   * 0.01) * (operationTerm / 365);

    const beforeTax          = Math.floor(profit + trimCapitalAmount);
    const tax                = Math.floor(taxBase * this.$WITHHOLDING_TAX_RATE);
    const afterTax           = Math.floor(beforeTax - tax);

    this.$afterTax.innerText  = '¥' + afterTax.toLocaleString();
    this.$beforeTax.innerText = '¥' + beforeTax.toLocaleString();
    this.$tax.innerText       = '¥' + tax.toLocaleString();
  }
  replaceToDateTimeFormat(targetDate) {
    let operationTargetDate = targetDate.textContent;
    ['年', '月'].map((el) => { operationTargetDate = operationTargetDate.replace(el, '/'); });
    return operationTargetDate.slice(0, -1);
  }
}
